import React, { useEffect } from 'react'

import { DietDetails, Folder } from '../../../../api/services/dietbase/types.ts'
import DietList from '../../../../pages/daymenus/DietList.tsx'
import Accordion, { AccordionChildren } from '../../../common/Accordion'
import ToggleOptionSharing from '../ToggleOptionSharing'

type DisplayFoldersProps = {
  daymenusSelected: string | null
  filteredFolders: Folder[]
  handleSelectionFolder: (folderId: number) => void
  optionSharingSelected: 'folder' | 'diet' | null
  setOptionSharing: (option: 'folder' | 'diet' | null) => void
  getDietDetails?: (details: DietDetails | null, dietID: number | null) => void
  getStatusLoadingDietList?: (status: boolean) => void
  getSelectedFolder?: (folder: number | null) => void
}

const DisplayFolders = ({
  daymenusSelected,
  filteredFolders,
  handleSelectionFolder,
  optionSharingSelected,
  setOptionSharing: handleSOptionSharing,
  getDietDetails,
  getStatusLoadingDietList,
  getSelectedFolder
}: DisplayFoldersProps) => {
  const [selectedFolder, setSelectedFolder] = React.useState<number | null>(
    null
  )
  const [currentCategory, setCurrentCategory] = React.useState<number | null>(
    null
  )
  const [usedDietsIds, setUsedDietsIds] = React.useState<number[]>([])

  useEffect(() => {
    if (filteredFolders.length > 0) {
      if (currentCategory !== filteredFolders[0]?.category)
        setSelectedFolder(null)
    }
    setCurrentCategory(filteredFolders[0]?.category)
  }, [filteredFolders])

  useEffect(() => {
    getSelectedFolder?.(selectedFolder)
    if (!selectedFolder) getDietDetails?.(null, null)
  }, [selectedFolder])

  const handleSelect = (props: AccordionChildren) => {
    if (optionSharingSelected === 'diet') {
      props.setSqueezed(!props.squeezed)
      props.setLabel(props.newLabel)
    }
  }

  const render = ({
    squeezed,
    setSqueezed,
    setLabel,
    toggleSqueeze
  }: AccordionChildren) => {
    return filteredFolders.map((folder: Folder) => {
      const canUseIt = !(folder.used_diets_ids.length === folder.diets_count)
      const styleDependsOnCanUseIt = !canUseIt
        ? 'font-normal dark:text-gray-500'
        : ''
      const textStyleDependsOnCanUseIt = `text-gray-600 dark:text-gray-200 ${styleDependsOnCanUseIt}`

      return (
        <div key={folder.id} className={'overflow-auto'}>
          <div
            key={folder.id}
            className={`flex items-center min-w-100 my-2 w-full border border-gray-200 py-2 ${folder.selected ? 'border-2 bg-green-200 dark:bg-green-800 border-green-700' : ''} ${!canUseIt ? 'bg-red-50 dark:bg-red-900 border-red-500' : 'border-green-500'}`}
            onClick={() => {
              setSelectedFolder(folder.id)
              setUsedDietsIds(folder.used_diets_ids)
              return optionSharingSelected === 'folder'
                ? folder.used_diets_ids.length === folder.diets_count
                  ? null
                  : handleSelectionFolder(folder.id)
                : handleSelect({
                    squeezed,
                    setSqueezed,
                    setLabel,
                    newLabel: `${folder.folder_category.toString()} (Liczba posiłków: ${folder.number_of_meals.toString()}, liczba kalorii: ${folder.kcal.toString()})`,
                    toggleSqueeze
                  })
            }}
          >
            <div
              className={'flex-row w-full justify-between items-center px-4'}
            >
              <span
                className={`text-xl font-bold text-gray-600 dark:text-gray-200 ${styleDependsOnCanUseIt}`}
              >
                {folder.folder_category}
              </span>
              <div className={'flex items-start p-2 gap-x-20'}>
                <div>
                  <p className={textStyleDependsOnCanUseIt}>
                    Ilość posiłków: {folder.number_of_meals}
                  </p>
                  <p className={textStyleDependsOnCanUseIt}>
                    Kalorie: {folder.kcal}
                  </p>
                </div>
                <div className={'border border-gray-200 rounded-md p-2'}>
                  <p className={'text-gray-600 dark:text-gray-200'}>
                    {`Ilość wykorzystana: ${folder.used_diets_ids.length} / ${folder.diets_count}`}
                  </p>
                </div>
              </div>
            </div>
            <div className={'flex px-4'}>
              <input
                type="checkbox"
                className="size-6 mr-2"
                checked={folder.selected}
                onChange={() => null}
                disabled={!canUseIt}
              />
            </div>
          </div>
        </div>
      )
    })
  }

  return (
    <div>
      <ToggleOptionSharing
        optionSharingSelected={optionSharingSelected}
        setOptionSharing={handleSOptionSharing}
      />

      <Accordion
        key={`accordion-${optionSharingSelected}-${currentCategory}`}
        title={''}
        onSqueezeChange={(squeezed) => {
          if (!squeezed) setSelectedFolder(null)
        }}
      >
        {({ squeezed, setSqueezed, setLabel, toggleSqueeze }) => {
          return render({ squeezed, setSqueezed, setLabel, toggleSqueeze })
        }}
      </Accordion>

      {selectedFolder !== null && daymenusSelected !== null && (
        <DietList
          isEditable={false}
          isGlobal={daymenusSelected === 'global'}
          folderID={selectedFolder}
          useDietsIds={usedDietsIds}
          getDietDetails={getDietDetails}
          getStatusLoadingDietList={getStatusLoadingDietList}
        />
      )}
    </div>
  )
}

export default DisplayFolders
